export default class UserProfileViewModel {
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
}